<app-header-crm class="header"></app-header-crm>
<app-menu-crm>
  <div class="main">
    <div class="overflow-auto scrollbar-visible">
      <router-outlet></router-outlet>
    </div>
  </div>
</app-menu-crm>
